<div class="well">
  @if (!submitted) {
    <form (ngSubmit)="onSubmit()" #contactUsForm="ngForm">
      <div class="form-group">
        <label for="firstName">First Name</label>
        <input type="text" class="form-control" id="firstName" required [(ngModel)]="model.firstName" name="firstName" #firstName="ngModel">
        <div [hidden]="firstName.valid || firstName.pristine" class="alert alert-danger">
          First Name is required
        </div>
      </div>
      <div class="form-group">
        <label for="lastName">Last Name</label>
        <input type="text" class="form-control" id="lastName" required [(ngModel)]="model.lastName" name="lastName" #lastName="ngModel">
        <div [hidden]="lastName.valid || lastName.pristine" class="alert alert-danger">
          Last Name is required
        </div>
      </div>
      <div class="form-group">
        <label for="email">Email Address</label>
        <input type="text" class="form-control" id="email" email [(ngModel)]="model.email" name="email" #email="ngModel">
        <div [hidden]="model.email === undefined || model.email.length === 0 || email.valid || email.pristine" class="alert alert-danger">
          Email Address is not valid
        </div>
      </div>
      <div class="form-group">
        <label for="phone">Phone Number</label>
        <input type="text" class="form-control" id="phone" [(ngModel)]="model.phone" name="phone" #phone="ngModel">
        <div [hidden]="phoneValid" class="alert alert-danger">
          Either email address or phone number is required.
        </div>
      </div>
      <button type="submit" class="btn btn-primary">
        @if (loading) {
          <i class="fa fa-spinner fa-spin fa-fw"></i>
        }
        Submit
      </button>
    </form>
  }
  @if (submitted) {
    <div style="font-weight: bold; text-align:center; padding: 2em;">
      Thank you. Someone will contact you as soon as possible.
    </div>
  }
</div>